import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { ExtendedDosage } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { DraftPrescriptionsFormController } from '../../draftPrescriptions/DraftPrescriptionsForm.types';
import { DraftStandardPrescriptionFieldName } from '../../draftPrescriptions/standardPrescription/DraftStandardPrescriptionField.types';

import { StyledCreateExtendedDosageLink } from './CreateExtendedDosageLink.styled';
import { ExtendedDosageModalOpener } from './ExtendedDosageModal.opener';

type CreateExtendedDosageLinkProps = Pick<DraftPrescriptionsFormController, 'setValue'> & {
   readonly name: DraftStandardPrescriptionFieldName;
   readonly dosageFieldName: DraftStandardPrescriptionFieldName;
   readonly dosage: string | null;
   readonly extendedDosage: ExtendedDosage | null;
   readonly medicine: MedicineSimple;
   readonly reimbursements: PatientMedicine['reimbursements'];
   readonly dosageFrequencyValidated: boolean;
   readonly visitDiagnoses: VisitDiagnosis[];
};

export const CreateExtendedDosageLink = (props: CreateExtendedDosageLinkProps): JSX.Element => {
   return (
      <ExtendedDosageModalOpener
         setValue={props.setValue}
         name={props.name}
         dosageFieldName={props.dosageFieldName}
         dosage={props.dosage}
         extendedDosage={props.extendedDosage}
         medicine={props.medicine}
         reimbursements={props.reimbursements}
         dosageFrequencyValidated={props.dosageFrequencyValidated}
         visitDiagnoses={props.visitDiagnoses}
      >
         {({ openModal }) => (
            <StyledCreateExtendedDosageLink
               testId={'createExtendedDosage'}
               label={prescriptionTranslationKeys.extendedDosage.create}
               onClick={openModal}
               block={false}
            />
         )}
      </ExtendedDosageModalOpener>
   );
};
